import { InvoiceTypes } from '@/shared/api/invoices'
import * as yup from 'yup'

export const createInvoiceValidationSchema = yup.object().shape({
    type: yup.string().oneOf([InvoiceTypes.aviabooking, InvoiceTypes.discounts, InvoiceTypes.fuel, InvoiceTypes.foodService]).required(),
    amount: yup.number().min(100, "Минимальная сумма - 100").typeError('Укажите число').required('Укажите количество бонусов'),
    ofertaAccepted: yup.boolean().oneOf([true], 'Для создания счета необходимо согласиться с условиями оферты')
})